import {iframeResize} from "iframe-resizer";

iframeResize({ log:false, checkOrigin:false });

